const theme = {
    id: 'dark',
    primaryColor: '#00090D',
    secondaryColor: '#014866',
    bodyBackgroundColor: '#00090D',
    bodyFontColor: '#ffffff'
};

export default theme;